import React from "react";
import { Toast, Button } from "antd-mobile";
import { post } from "../../utils/request";
import { href } from "../../utils/util";
// import QRCode from "qrcode";

import api from "./api";
import stepImg from "./images/ts.png";

import "./index.less";
class yysChargingOperatorIndex extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      urlOps: {},
      modalImgCodeType: false,
      status: 0,

      detailData: {},
      qrImg: "",
    };
    this.hasRequestedStatus = false; // 防止重复请求
  }

  // #/yysChargingOperatorIndex?app_stoken=xxxx
  componentDidMount() {
    console.log("[yysChargingOperatorIndex] componentDidMount 被调用");

    // 防止重复初始化
    if (this._hasInitialized) {
      console.log("[yysChargingOperatorIndex] 已经初始化过，跳过");
      return;
    }
    this._hasInitialized = true;

    this.initPage();
  }

  // 提取初始化逻辑为独立方法
  initPage() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }

      if (
        ops.app_stoken === "null" ||
        ops.app_stoken === "(null)" ||
        ops.app_stoken === "undefined" ||
        !ops.app_stoken
      ) {
        Toast.fail("请登录APP再进行操作", 999);
        return;
      }
      console.log("[yysChargingOperatorIndex] 设置 urlOps 并调用 getStatus");
      this.setState(
        {
          urlOps: ops,
        },
        () => {
          this.getStatus();
        },
      );
    }
  }

  getStatus() {
    console.log(
      "[yysChargingOperatorIndex] getStatus 被调用, hasRequestedStatus:",
      this.hasRequestedStatus,
    );
    // 防止重复请求
    if (this.hasRequestedStatus) {
      console.log("[yysChargingOperatorIndex] 已请求过，跳过此次调用");
      return Promise.resolve();
    }
    this.hasRequestedStatus = true;

    const { urlOps } = this.state;
    console.log(
      "[yysChargingOperatorIndex] 发起 selectChargeCarrierApplyStatus 请求",
    );
    return post({
      url:
        api.selectChargeCarrierApplyStatus + "?app_stoken=" + urlOps.app_stoken,
      data: {},
    }).then(
      (res) => {
        console.log(
          "[yysChargingOperatorIndex] selectChargeCarrierApplyStatus 请求成功, res.data:",
          res.data,
        );
        if (res.result === "success") {
          if (res.data == 2) {
            this.getDetail();
            // href(`/yysChargingOperatorSuccess?app_stoken=${urlOps.app_stoken}`)
          }
          this.setState({
            status: res.data, //审核状态 （0:未申请；1：待审核；2：审核通过；3：审核拒绝；）
          });
        } else {
          Toast.info(res.msg, 1);
        }
      },
      (res) => {
        console.log(
          "[yysChargingOperatorIndex] selectChargeCarrierApplyStatus 请求失败",
        );
        Toast.info("审核状态查询查询失败", 1);
      },
    );
  }

  // 申请
  applyChargeCarrier() {
    const { urlOps } = this.state;
    post({
      url: api.applyChargeCarrier + "?app_stoken=" + urlOps.app_stoken,
      data: {},
    }).then(
      (res) => {
        if (res.result === "success") {
          Toast.info("申请成为充电合伙人成功，请等待审核。", 1);
          this.getStatus();
          this.setState({
            modalImgCodeType: false,
          });
        } else {
          Toast.info(res.msg, 1);
        }
      },
      (res) => {
        Toast.info("充电合伙人申请失败", 1);
      },
    );
  }

  viewPort = () => {
    let u = navigator.userAgent.toLowerCase();
    return {
      isWeixin: u.indexOf("micromessenger") > -1,
      isQQ: u.indexOf("qq/") > -1,
      trident: u.indexOf("trident") > -1, //IE内核
      presto: u.indexOf("presto") > -1, //opera内核
      webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
      mobile: !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
      android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
      iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("ipad") > -1, //是否iPad
      webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
    };
  };

  appShare(ops) {
    let viewPort = this.viewPort();
    if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
      if (window.webkit) {
        window.webkit.messageHandlers.shareLink.postMessage(ops);
      }
    } else {
      if (window.huilian) {
        window.huilian.shareLink(ops.url, ops.title, ops.cotent, ops.img);
      }
    }
  }

  // 判断当前用户是否可以邀请
  checkCanInvite(callback) {
    const { urlOps } = this.state;
    post({
      url: api.getInviteQrCodeDetail + "?app_stoken=" + urlOps.app_stoken,
      data: {},
    }).then(
      (res) => {
        if (res.result === "success") {
          if (res.data.isCanInvite === 1) {
            callback && callback(res.data);
          } else {
            Toast.info("充电合伙人已过期，请联系客服", 1);
          }
        } else {
          Toast.info(res.msg, 1);
        }
      },
      (res) => {
        Toast.info("邀请权限查询失败", 1);
      },
    );
  }

  // 获取详情
  getDetail() {
    const { urlOps } = this.state;
    post({
      url: api.myChargeCarrierDetail + "?app_stoken=" + urlOps.app_stoken,
      data: {},
    }).then(
      (res) => {
        if (res.result === "success") {
          this.setState({
            detailData: res.data,
          });
          // QRCode.toDataURL(
          //     `${window.location.origin}/payment/#/yysChargingOperatorShare?inviteCode=${res.data.partyId}&name=${res.data.customerName}`,
          //     {
          //         errorCorrectionLevel: "H",
          //         type: "image/jpeg",
          //         quality: 0.3,
          //         margin: 1,
          //     },
          //     (err, url) => {
          //         if (err) throw err;
          //         console.log(url);
          //         this.setState({
          //             qrImg: url,
          //         });
          //     }
          // );
        } else {
          Toast.info(res.msg, 1);
        }
      },
      (res) => {
        Toast.info("获取充电合伙人详情失败", 1);
      },
    );
  }

  render() {
    const { modalImgCodeType, urlOps, status, qrImg, detailData } = this.state;
    // console.log(urlOps)
    return status != 2 ? (
      <div className="yysChargingOperatorIndexBox">
        <div className="registerBox">
          <img src={stepImg} className="stepImg" alt="" />

          {status == 0 || status == 3 ? (
            <div
              className="reward_3_row"
              onClick={() => {
                this.setState({
                  modalImgCodeType: true,
                });
              }}
            >
              立即申请
            </div>
          ) : (
            ""
          )}

          {status == 1 ? (
            <div className="reward_3_row">后台审核中，请耐心等待</div>
          ) : (
            ""
          )}
        </div>

        <div className="introduceBox">
          <h2>成为充电合伙人您可以</h2>
          <div>
            <div>
              <h3>充电折扣</h3>
              <div>运营商将在合作期内给予充电折扣</div>
            </div>
            <div>
              <h3>统一开票</h3>
              <div>邀请用户的充电订单支持统一开票</div>
            </div>
            <div>
              <h3>赚返利金</h3>
              <div>发展用户赚取返利金</div>
            </div>
          </div>
        </div>

        {modalImgCodeType ? (
          <div className="modalImgCodeBox">
            <div>
              <div className="modalImgCodeContent">
                <h3>确定申请成为充电合伙人吗</h3>
                <div className="inputBox">申请后请及时联系您的客户经理处理</div>
              </div>
              <div className="btnBox">
                <a
                  onClick={() => {
                    this.setState({
                      modalImgCodeType: false,
                      imageCode: "",
                    });
                  }}
                >
                  取消
                </a>
                <a
                  onClick={() => {
                    this.applyChargeCarrier();
                  }}
                >
                  确定
                </a>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    ) : (
      <div className="yysChargingOperatorSuccessBox">
        <div className="registerBox">
          <div>
            <div className="registerTitle">
              邀请用户每充电一笔订单可开票和返利
            </div>
            {detailData.status === "已终止" ? (
              <div className="registerTime error">合作已到期，请重新申请</div>
            ) : (
              <div className="registerTime">
                合作时间：
                {detailData.settleDate
                  ? detailData.settleDate.slice(0, 10)
                  : ""}
                ～
                {detailData.invalidDate
                  ? detailData.invalidDate.slice(0, 10)
                  : ""}
              </div>
            )}
          </div>
          {/* <div className="qrBox">
                        <div className="qr">
                            {qrImg ? <img src={qrImg} /> : ""}
                        </div>
                        <div
                            className="qrBtn"
                            onClick={() => {
                                let viewPort = this.viewPort();
                                const ops = {
                                    url: `${
                                        window.location.origin
                                    }/payment/#/yysChargingOperatorShare?inviteCode=${
                                        detailData.partyId
                                    }&name=${encodeURIComponent(
                                        detailData.customerName
                                    )}`,
                                };
                                if (
                                    viewPort.ios ||
                                    viewPort.iPhone ||
                                    viewPort.iPad
                                ) {
                                    if (window.webkit) {
                                        window.webkit.messageHandlers.downloadQrCode.postMessage(
                                            ops
                                        );
                                    }
                                } else {
                                    if (window.huilian) {
                                        window.huilian.downloadQrCode(ops.url);
                                    }
                                }
                            }}
                        >
                            保存二维码
                        </div>
                    </div> */}
          <div style={{ marginTop: "0.3rem" }}>
            {detailData.status === "已入驻" ? (
              <div
                className="reward_3_row"
                style={{ marginBottom: "0.14rem" }}
                onClick={() => {
                  this.checkCanInvite(() => {
                    href(
                      `/yysChargingOperatorQr?app_stoken=${urlOps.app_stoken}`,
                    );
                  });
                }}
              >
                邀请二维码
              </div>
            ) : (
              ""
            )}
            {detailData.status === "已终止" ? (
              detailData.applyCheckingCount > 0 ? (
                <div
                  className="reward_3_row"
                  style={{ marginBottom: "0.14rem" }}
                >
                  后台审核中，请耐心等待
                </div>
              ) : (
                <div
                  className="reward_3_row"
                  style={{ marginBottom: "0.14rem" }}
                  onClick={() => {
                    this.applyChargeCarrier();
                  }}
                >
                  申请续约
                </div>
              )
            ) : (
              <div
                className="reward_3_row"
                style={{ marginBottom: "0.14rem" }}
                onClick={() => {
                  this.checkCanInvite(() => {
                    this.appShare({
                      url: `${
                        window.location.origin
                      }/payment/#/yysChargingOperatorShare?inviteCode=${
                        detailData.partyId
                      }&name=${encodeURIComponent(detailData.customerName)}`,
                      title: "注册远程慧联app充电",
                      cotent: "享受遍布全国超50万充电桩服务",
                      img: "https://static.hellogil.com/staticResource/payment/charge_share.png",
                    });
                  });
                }}
              >
                邀请用户
              </div>
            )}
            <div
              className="reward_3_row default"
              onClick={() => {
                href(
                  `/yysChargingOperatorDetail?app_stoken=${urlOps.app_stoken}`,
                );
              }}
            >
              返利明细
            </div>
          </div>
        </div>
        <div>
          <h2>邀请用户规则</h2>
          <div className="detailText" style={{ lineHeight: "1.5" }}>
            1、邀请的用户有且仅可以所属一家充电合伙人；
            <br />
            2、若当前用户已与其他充电合伙人绑定，需先行解绑再重新邀请绑定；
            <br />
            3、邀请用户可为个体用户或车队/公司用户；
            <br />
            4、不支持邀请用户为充电合伙人身份。
          </div>
          <h2 style={{ marginTop: "0.16rem" }}>司机充电及返利</h2>
          <div className="detailText" style={{ lineHeight: "1.5" }}>
            1、登录充电合伙人后台可设置邀请用户充电折扣；
            <br />
            2、手机端支持通过充电合伙人账户分配对应金额到邀请用户伙伴卡中；
            <br />
            3、邀请用户充电可选择伙伴卡进行充电订单支付；
            <br />
            4、订单返利金额将会在订单结算完成后充值到充电合伙人的伙伴卡账户余额中。
          </div>
          <h2 style={{ marginTop: "0.16rem" }}>关于开票</h2>
          <div className="detailText" style={{ lineHeight: "1.5" }}>
            1、平台只给充电合伙人提供开票服务；
            <br />
            2、平台提供的开票金额包含:充电合伙人充电订单，充电合伙人邀请用户通过伙伴卡的充电订单，开票金额均为实际支付金额（不包含返利和其他活动赠送金额）；
            <br />
            3、充电合伙人邀请的用户开票由充过电充电合伙人自行提供，平台不提供该部分订单开票给邀请司机。
          </div>
          <div
            className="reward_3_row"
            style={{ marginTop: "0.24rem" }}
            onClick={() => {
              let viewPort = this.viewPort();
              if (viewPort.ios || viewPort.iPhone || viewPort.iPad) {
                if (window.webkit) {
                  window.webkit.messageHandlers.invoices.postMessage("1");
                }
              } else {
                if (window.huilian) {
                  window.huilian.invoices();
                }
              }
            }}
          >
            去开票
          </div>
        </div>
      </div>
    );
  }
}

export default yysChargingOperatorIndex;



// WEBPACK FOOTER //
// ./src/yysChargingOperator/index/index.js